import React from 'react';
import PropTypes from 'prop-types';

const overlayStyle = {
    backgroundColor: '#00000087',
};

const centerBoxStyle = {
    maxWidth: '800px',
    top: '45%',
    transform: 'translate(0%,-45%)',
    overflow: 'hidden',
    height: 'max-content',
};

const TransparentBackgroundOverlay = (props) => {
    // note that, tailwind supports only values 0, 10, 20, 30, 40, 50
    // session expired popup has z-index 40, and reportIssue has 50.
    // if you are not sure, leave the value to be default.
    const { header, onClose, zIndex = 10 } = props;

    return (
        <div
            className={`text-left fixed top-0 left-0 w-full h-screen flex item-center justify-center z-10`}
            style={{ ...overlayStyle, zIndex }} // todo: Remove when migrating to Tailwind v3+ (which supports JIT mode). Currently, inline style is added to avoid CSS purging of dynamic z-index classes in builds.
        >
            <div
                className="relative bg-white w-4/5 mx-auto rounded min-h-0"
                style={centerBoxStyle}
            >
                <div className="flex items-center justify-between text-blue-700 font-semibold py-4 text-lg px-4 bg-blue-100  border border-gray-200">
                    {header}
                    {props.hideCloseButton ? (
                        <span />
                    ) : (
                        <span
                            className="cursor-pointer px-2"
                            onClick={onClose}
                            data-testid="close-btn"
                        >
                            X
                        </span>
                    )}
                </div>
                <div>{props.children}</div>
            </div>
        </div>
    );
};

TransparentBackgroundOverlay.propTypes = {
    header: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.any,
    zIndex: PropTypes.number,
    hideCloseButton: PropTypes.bool,
};

export default TransparentBackgroundOverlay;
